import { render, staticRenderFns } from "./vendorAttach.vue?vue&type=template&id=9a8e7dc4"
import script from "./vendorAttach.vue?vue&type=script&lang=js"
export * from "./vendorAttach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a8e7dc4')) {
      api.createRecord('9a8e7dc4', component.options)
    } else {
      api.reload('9a8e7dc4', component.options)
    }
    module.hot.accept("./vendorAttach.vue?vue&type=template&id=9a8e7dc4", function () {
      api.rerender('9a8e7dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/csm/vendorAttach.vue"
export default component.exports